"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPopNearbyTabType = void 0;
var DetailPopNearbyTabType;
(function (DetailPopNearbyTabType) {
    DetailPopNearbyTabType[DetailPopNearbyTabType["NONE"] = 0] = "NONE";
    DetailPopNearbyTabType[DetailPopNearbyTabType["MYPLACE"] = 1] = "MYPLACE";
    DetailPopNearbyTabType[DetailPopNearbyTabType["FAVORITES"] = 2] = "FAVORITES";
    DetailPopNearbyTabType[DetailPopNearbyTabType["HISTORY"] = 3] = "HISTORY";
    DetailPopNearbyTabType[DetailPopNearbyTabType["PROPERTIES"] = 4] = "PROPERTIES";
    DetailPopNearbyTabType[DetailPopNearbyTabType["SCHOOL"] = 5] = "SCHOOL";
    DetailPopNearbyTabType[DetailPopNearbyTabType["BANK"] = 6] = "BANK";
    DetailPopNearbyTabType[DetailPopNearbyTabType["HOSPITAL"] = 7] = "HOSPITAL";
    DetailPopNearbyTabType[DetailPopNearbyTabType["RAILWAY"] = 8] = "RAILWAY";
    DetailPopNearbyTabType[DetailPopNearbyTabType["BUS"] = 9] = "BUS";
    DetailPopNearbyTabType[DetailPopNearbyTabType["RESTAURANT"] = 10] = "RESTAURANT";
    DetailPopNearbyTabType[DetailPopNearbyTabType["STORE"] = 11] = "STORE";
})(DetailPopNearbyTabType = exports.DetailPopNearbyTabType || (exports.DetailPopNearbyTabType = {}));
